/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelist_NewInputs */

const id_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`baru`)
};

const ms_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`baharu`)
};

const da_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ny`)
};

const de_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`neu`)
};

const en_us2_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`new`)
};

const es_es2_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nuevo`)
};

const es_mx2_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nuevo`)
};

const fil_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bago`)
};

const fr_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nouveau`)
};

const it_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nuovo`)
};

const hu_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`új`)
};

const nl_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nieuw`)
};

const no_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ny`)
};

const pl_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nowe`)
};

const pt_br2_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const pt_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`novo`)
};

const ro_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nou`)
};

const fi_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uusi`)
};

const sv_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ny`)
};

const vi_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mới`)
};

const tr_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yeni`)
};

const cs_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nový`)
};

const bg_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ново`)
};

const ru_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`новое`)
};

const uk_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`нове`)
};

const ar_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جديد`)
};

const hi_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया`)
};

const th_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใหม่`)
};

const ja_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新規`)
};

const zh_cn2_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const zh_hant1_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const ko_components_changelist_new = /** @type {(inputs: Components_Changelist_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

/**
* | output |
* | --- |
* | "new" |
*
* @param {Components_Changelist_NewInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelist_new = /** @type {((inputs?: Components_Changelist_NewInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelist_NewInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelist_new(inputs)
	if (locale === "ms") return ms_components_changelist_new(inputs)
	if (locale === "da") return da_components_changelist_new(inputs)
	if (locale === "de") return de_components_changelist_new(inputs)
	if (locale === "en-US") return en_us2_components_changelist_new(inputs)
	if (locale === "es-ES") return es_es2_components_changelist_new(inputs)
	if (locale === "es-MX") return es_mx2_components_changelist_new(inputs)
	if (locale === "fil") return fil_components_changelist_new(inputs)
	if (locale === "fr") return fr_components_changelist_new(inputs)
	if (locale === "it") return it_components_changelist_new(inputs)
	if (locale === "hu") return hu_components_changelist_new(inputs)
	if (locale === "nl") return nl_components_changelist_new(inputs)
	if (locale === "no") return no_components_changelist_new(inputs)
	if (locale === "pl") return pl_components_changelist_new(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelist_new(inputs)
	if (locale === "pt") return pt_components_changelist_new(inputs)
	if (locale === "ro") return ro_components_changelist_new(inputs)
	if (locale === "fi") return fi_components_changelist_new(inputs)
	if (locale === "sv") return sv_components_changelist_new(inputs)
	if (locale === "vi") return vi_components_changelist_new(inputs)
	if (locale === "tr") return tr_components_changelist_new(inputs)
	if (locale === "cs") return cs_components_changelist_new(inputs)
	if (locale === "bg") return bg_components_changelist_new(inputs)
	if (locale === "ru") return ru_components_changelist_new(inputs)
	if (locale === "uk") return uk_components_changelist_new(inputs)
	if (locale === "ar") return ar_components_changelist_new(inputs)
	if (locale === "hi") return hi_components_changelist_new(inputs)
	if (locale === "th") return th_components_changelist_new(inputs)
	if (locale === "ja") return ja_components_changelist_new(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelist_new(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelist_new(inputs)
	return ko_components_changelist_new(inputs)
});
export { components_changelist_new as "components.changelist.new" }